export const getImageFilenameFromUrl = url => {
  try {
    const {
      pathname
    } = new URL(url);
    const parts = pathname.split('/');
    const mediaIndex = parts.findIndex(p => p === 'media' || p === 'shapes');
    if (mediaIndex !== -1 && parts[mediaIndex + 1]) {
      return parts[mediaIndex + 1];
    }
    return '';
  } catch {
    return url;
  }
};
//# sourceMappingURL=get-image-filename-from-url.js.map